<template>
  <div class="containerTable">
    <!-- 货源管理 -->
    <vxe-toolbar id="toolbarId_or33" export :refresh="{ query: RefreshList }">
      <template v-slot:buttons>
        <el-button v-if="order_manage_search_button" @click="funcFilter">
          查询
        </el-button>
        <el-button
          v-if="getLimit('order_manage_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
        <el-button @click="columnSettingVisible = true">列设置</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      v-if="showTable"
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      :loading="loading"
      :cell-class-name="cellClassName"
      :row-class-name="rowClassName"
      class="mytable-footer"
      height="80%"
      :footer-method="footerMethod"
      :data="tableData"
      :sort-config="{ remote: true }"
      align="center"
      export-config
      :show-overflow="null"
      :scroll-y="{ gt: -1, enabled: false }"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column v-if="isSub">
        <vxe-table-column
          field="companyName"
          title="子公司名称"
          min-width="200"
          fixed="left"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyName"
            placeholder="请输入子公司名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column
        v-for="col in columns"
        v-if="col.visible"
        :key="col.value"
      >
        <vxe-table-column
          :field="col.value"
          :title="col.name"
          :min-width="col.minWidth || 160"
        >
          <template #default="scope">
            <div class="oeder_num_box">
              <span
                class="copy_text_span"
                @click="copyText(formatterSwitch(scope))"
                v-html="formatterSwitch(scope)"
              />
            </div>
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <template v-if="col.value === 'branchCode'">
            <el-select
              v-model="listQuery.branchCode"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in branchList"
                :key="item.code"
                :label="item.groupName"
                :value="item.code"
              />
            </el-select>
          </template>
          <template
            v-if="
              col.value === 'mainOrderNumber' ||
                col.value === 'sourceOrderNumber' ||
                col.value === 'projectName' ||
                col.value === 'lineName' ||
                col.value === 'companyName' ||
                col.value === 'dfName' ||
                col.value === 'createdByPhone' ||
                col.value === 'placeOfShipment' ||
                col.value === 'placeOfReceipt' ||
                col.value === 'coalTypeName' ||
                col.value === 'coalBigTypeName' ||
                col.value === 'coalName' ||
                col.value === 'modifiedByName'
            "
          >
            <el-input
              v-model="listQuery[col.value]"
              placeholder="请输入"
              clearable
            />
          </template>
          <template v-if="col.value === 'receiveOrderMethod'">
            <el-select
              v-model="listQuery.receiveOrderMethod"
              clearable
              placeholder="请选择接单方式"
            >
              <el-option label="发布至大厅" :value="0" />
              <el-option label="仅扫码接单" :value="1" />
            </el-select>
          </template>
          <template v-if="col.value === 'shipmentStaffType'">
            <el-select
              v-model="listQuery.shipmentStaffType"
              clearable
              placeholder="请选择托运人类型"
            >
              <el-option label="托运人" :value="0" />
              <el-option label="托运人" :value="0" />
            </el-select>
          </template>
          <template v-if="col.value === 'isMonthlyOrder'">
            <el-select
              v-model="listQuery.isMonthlyOrder"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in parentData.isMonthlyOrderOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-if="col.value === 'status'">
            <el-select
              v-model="listQuery.status"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-if="col.value === 'isQuote'">
            <el-select
              v-model="listQuery.supplyType"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="(v, k) in isQuoteMap"
                :key="k"
                :label="v"
                :value="k"
              />
            </el-select>
          </template>
          <template v-if="col.value === 'isFinishOrder'">
            <el-select
              v-model="listQuery.isFinishOrder"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in finishOrders"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-if="col.value === 'isCancel'">
            <el-select
              v-model="listQuery.isCancel"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in cancels"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-if="col.value === 'isOftenOrder'">
            <el-select
              v-model="listQuery.isOftenOrder"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options3"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-if="col.value === 'shipmentStaffTypeStr'">
            <el-select
              v-model="listQuery.shipmentStaffType"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in shipmentOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-if="col.value === 'coalPrice'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.coalPriceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.coalPriceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'goodsTotal'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.goodsTotalStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.goodsTotalEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'price'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.priceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.priceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'realPrice'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.realPriceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.realPriceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'payType'">
            <el-select
              v-model="listQuery.payType"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options3"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-if="col.value === 'prePay'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.prePayStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.prePayEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'arrivePayType'">
            <el-select
              v-model="listQuery.arrivePayType"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options3"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-if="col.value === 'arrivePay'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.arrivePayStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.arrivePayEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'returnPayType'">
            <el-select
              v-model="listQuery.returnPayType"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options3"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-if="col.value === 'returnPay'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.returnPayStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.returnPayEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'driftPrice'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.driftPriceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.driftPriceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'dirverEstimatePay'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.allFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.allFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'shipperEstimatePay'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.taxFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.taxFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'serInfoPay'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.taxPayFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.taxPayFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'distance'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.distanceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.distanceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'weight'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.weightStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.weightEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'lastWeight'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.lastWeightStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.lastWeightEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'coalNumber'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.coalNumberStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.coalNumberEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'notReceivedCount'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.notReceivedCountStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.notReceivedCountEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'receivedCount'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.receivedCountStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.receivedCountEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'lastLoadingTime'">
            <el-date-picker
              v-model="listQuery.lastLoadingTimeRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'lastLoadingTime')"
            />
          </template>
          <template v-if="col.value === 'lastUnloadingTime'">
            <el-date-picker
              v-model="listQuery.lastUnloadingTimeRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'lastUnloadingTime')"
            />
          </template>
          <template v-if="col.value === 'gmtCreated'">
            <el-date-picker
              v-model="listQuery.gmtCreatedRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'gmtCreated')"
            />
          </template>
          <template v-if="col.value === 'gmtModified'">
            <el-date-picker
              v-model="listQuery.gmtModifiedRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'gmtModified')"
            />
          </template>
        </template>
      </vxe-table-column>
      <template v-if="false">
        <vxe-table-column>
          <vxe-table-column
            field="branchCode"
            title="承运主体"
            :formatter="formatterBranch"
            min-width="230"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.branchCode"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in branchList"
                :key="item.code"
                :label="item.groupName"
                :value="item.code"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="mainOrderNumber"
            title="货源单号"
            min-width="200"
            sortable
          >
            <template #default="{ row }">
              <div class="oeder_num_box">
                {{ row.mainOrderNumber }}
                <img
                  v-if="row.payType == 1"
                  class="icon_yu"
                  src="@/assets/icon/yu.png"
                  alt=""
                />
              </div>
            </template>
          </vxe-table-column>
          <template v-slot:header>
            <el-input
              v-model="listQuery.mainOrderNumber"
              placeholder="请输入货源单号"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 项目信息TODO 来源单号、项目名称、线路简称、接单方式 -->
        <vxe-table-column>
          <vxe-table-column
            field="sourceOrderNumber"
            title="来源单号"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.sourceOrderNumber"
              placeholder="请输入来源单号"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="projectName"
            title="项目名称"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.projectName"
              placeholder="请输入项目名称"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="lineName"
            title="线路简称"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.lineName"
              placeholder="请输入线路简称"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="receiveOrderMethod"
            title="接单方式"
            min-width="200"
            :formatter="formatterReceiveOrderMethod"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.receiveOrderMethod"
              clearable
              placeholder="请选择接单方式"
            >
              <el-option label="发布至大厅" :value="0" />
              <el-option label="仅扫码接单" :value="1" />
            </el-select>
          </template>
        </vxe-table-column>
        <!--  -->
        <vxe-table-column>
          <vxe-table-column
            field="companyName"
            title="托运人"
            min-width="260"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.companyName"
              placeholder="请输入托运人"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="dfName"
            title="经办人"
            min-width="120"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.dfName"
              placeholder="请输入经办人"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column>
        <vxe-table-column
          field="createdByName"
          title="托运人名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.createdByName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column> -->
        <vxe-table-column>
          <vxe-table-column
            field="shipmentStaffTypeStr"
            title="托运人类型"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.shipmentStaffType"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in shipmentOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="createdByPhone"
            title="托运人电话"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.createdByPhone"
              placeholder="请输入内容"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="isMonthlyOrder"
            title="结算类型"
            min-width="100"
            :formatter="
              ({ cellValue }) => formatterField({ cellValue }, 'isMonthlyOrder')
            "
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.isMonthlyOrder"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in parentData.isMonthlyOrderOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="placeOfShipment"
            title="装货地址"
            min-width="350"
            show-overflow
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.placeOfShipment"
              placeholder="请输入装货地址"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="placeOfReceipt"
            title="收货地址"
            min-width="350"
            show-overflow
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.placeOfReceipt"
              placeholder="请输入收货地址"
              clearable
            />
          </template>
        </vxe-table-column>

        <vxe-table-column>
          <vxe-table-column
            field="status"
            :formatter="formatterStatus"
            title="订单状态"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.status"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="isQuote"
            title="订单类型"
            :formatter="formatterQuote"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.supplyType"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="(v, k) in isQuoteMap"
                :key="k"
                :label="v"
                :value="k"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="isFinishOrder"
            :formatter="formatterFinishs"
            title="是否结束"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.isFinishOrder"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in finishOrders"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="isCancel"
            :formatter="formatterCancels"
            title="是否撤销"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.isCancel"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in cancels"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="coalTypeName"
            title="货物名称"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.coalTypeName"
              placeholder="请输入货物名称"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="coalBigTypeName"
            title="货物类型"
            min-width="180"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.coalBigTypeName"
              placeholder="请输入内容"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="isOftenOrder"
            :formatter="frequentGoods"
            title="是否常发货源"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.isOftenOrder"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options3"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="coalName"
            title="运输要求"
            min-width="130"
            show-overflow
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.coalName"
              placeholder="请输入运输要求"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column>
        <vxe-table-column field="billingType" :formatter="billingTypeStatus" title="开票方式" min-width="130" sortable />
        <template v-slot:header>
          <el-select v-model="listQuery.billingType" clearable placeholder="请选择">
            <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </template>
      </vxe-table-column> -->
        <vxe-table-column>
          <vxe-table-column
            field="coalPrice"
            title="货物单价"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.coalPriceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.coalPriceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="goodsTotal"
            title="货物总价(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.goodsTotalStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.goodsTotalEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="price"
            title="运费单价"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.priceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.priceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column>
        <vxe-table-column
          field="taxPrice"
          title="含税单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
        <vxe-table-column
          v-if="partyType != 'SHIPMENT' && partyType != 'SHIPMENT_COMPANY'"
        >
          <vxe-table-column
            field="realPrice"
            title="承运单价"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.realPriceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.realPriceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="payType"
            :formatter="frequentGoods"
            title="是否预付"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.payType"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options3"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="prePay"
            title="预付款(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.prePayStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.prePayEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="arrivePayType"
            :formatter="frequentGoods"
            title="是否到付"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.arrivePayType"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options3"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="arrivePay"
            title="到付款(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.arrivePayStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.arrivePayEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="returnPayType"
            :formatter="frequentGoods"
            title="是否回单付"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.returnPayType"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options3"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="returnPay"
            title="回单付款(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.returnPayStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.returnPayEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="driftPrice"
            title="浮动费用(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.driftPriceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.driftPriceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="dirverEstimatePay"
            title="实际承运人预估费用(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.allFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.allFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="shipperEstimatePay"
            title="预估托运人费用(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.taxFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.taxFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="serInfoPay"
            title="服务费(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.taxPayFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.taxPayFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>

        <!-- <vxe-table-column>
        <vxe-table-column
          field="maxPrice"
          title="最高价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.maxPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.maxPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="maxTaxPrice"
          title="最高含税价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.maxTaxPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.maxTaxPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column
        v-if="partyType != 'SHIPMENT' && partyType != 'SHIPMENT_COMPANY'"
      >
        <vxe-table-column
          field="maxRealPrice"
          title="最高承运单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.maxRealPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.maxRealPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
        <vxe-table-column>
          <vxe-table-column
            field="distance"
            title="运输距离(公里)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.distanceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.distanceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="weight"
            title="货物数量"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.weightStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.weightEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="lastWeight"
            title="剩余数量"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.lastWeightStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.lastWeightEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="coalNumber"
            title="需求车数(车)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.coalNumberStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.coalNumberEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="notReceivedCount"
            title="未接车数(车)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.notReceivedCountStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.notReceivedCountEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="receivedCount"
            title="已接车数(车)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.receivedCountStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.receivedCountEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column>
        <vxe-table-column
          field="transferCount"
          title="已调单量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.transferCountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.transferCountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
        <vxe-table-column>
          <vxe-table-column
            field="lastLoadingTime"
            title="装车时间"
            min-width="420"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.lastLoadingTimeRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'lastLoadingTime')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="lastUnloadingTime"
            title="卸车时间"
            min-width="420"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.lastUnloadingTimeRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'lastUnloadingTime')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="gmtCreated"
            title="创建时间"
            min-width="420"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.gmtCreatedRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'gmtCreated')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="gmtModified"
            title="最后操作时间"
            min-width="420"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.gmtModifiedRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'gmtModified')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="modifiedByName"
            title="最后操作人"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.modifiedByName"
              placeholder="请输入最后操作人"
              clearable
            />
          </template>
        </vxe-table-column>
      </template>

      <vxe-table-column title="操作" min-width="250" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="order_manage_detail_button"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="handleClick(scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.btnArr.indexOf('delete') > -1"
            effect="dark"
            content="取消"
            placement="top"
          >
            <vxe-button type="text" @click.native="del(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
          <!-- <el-tooltip
              class="item"
              effect="dark"
              content="电子围栏"
              placement="top"
            >
              <vxe-button type="text" @click="enClosure(scope.row)">
                <i class="el-icon-aim" />电子围栏
              </vxe-button>
            </el-tooltip> -->
          <el-tooltip
            v-if="order_manage_copy_button"
            class="item"
            effect="dark"
            content="再来一单"
            placement="top"
          >
            <vxe-button type="text" @click="copyClick(scope.row.code)">
              <i class="el-icon-s-management" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              order_manage_distr_button &&
                scope.row.isCancel === 0 &&
                scope.row.isFinishOrder === 0
            "
            effect="dark"
            content="指派实际承运人"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="
                distrClick({
                  huoyuan: scope.row.code,
                  branchCode: scope.row.branchCode
                })
              "
            >
              <i class="el-icon-thumb" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.btnArr.length > 0"
            effect="dark"
            content="更多"
            placement="left"
          >
            <el-dropdown>
              <el-button>
                <i class="el-icon-more" /><i
                  class="el-icon-arrow-down el-icon--right"
                />
              </el-button>
              <el-dropdown-menu slot:dropdowns>
                <el-dropdown-item
                  v-if="scope.row.btnArr.indexOf('edit') > -1"
                  @click.native="editClick(scope.row)"
                >
                  <i class="el-icon-edit-outline" />编辑
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="
                    order_manage_endsourcedoc_button &&
                      scope.row.isFinishOrder === 0
                  "
                >
                  <div @click="Endsourcedoc(scope.row.code)">
                    <i class="el-icon-circle-close" />结束货源单
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="scope.row.btnArr.indexOf('enclosure') > -1"
                  type="text"
                  @click.native="enClosure(scope.row)"
                >
                  <i class="el-icon-aim" />电子围栏
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="scope.row.btnArr.indexOf('suspend') > -1"
                  @click.native="suspend(scope.row.code)"
                >
                  <i class="el-icon-video-pause" />暂停
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="scope.row.btnArr.indexOf('orderrefresh') > -1"
                  @click.native="orderRefresh(scope.row.code)"
                >
                  <i class="el-icon-remove-outline" />刷新
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="scope.row.btnArr.indexOf('reject') > -1"
                  @click.native="rejectClick(scope.row)"
                >
                  <i class="el-icon-sort" />调价
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="scope.row.btnArr.indexOf('offer') > -1"
                  @click.native="offerOrder(scope.row.code)"
                >
                  <i class="el-icon-coin" />报价
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="scope.row.btnArr.indexOf('paidanList') > -1"
                  @click.native="paidanList(scope.row)"
                >
                  <i class="el-icon-s-grid" />派单列表
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="scope.row.btnArr.indexOf('cancelOftenOrder') > -1"
                  @click.native="cancelOftenOrder(scope.row.code)"
                >
                  <i class="el-icon-star-off" />取消常发
                </el-dropdown-item>
                <!-- v-if="scope.row.btnArr.indexOf('qrCode') > -1" -->
                <el-dropdown-item
                  @click.native="getCode(scope.row.code, scope.row)"
                >
                  <i class="el-icon-full-screen" />查看二维码
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="getLimit('order_manage_simple_button')"
                  @click.native="getCode(scope.row.code, scope.row, true)"
                >
                  <i class="el-icon-full-screen" />查看简易二维码
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="getLimit('order_manage_log_button')"
                  @click.native="watchLog(scope.row.code, scope.row)"
                >
                  <i class="el-icon-document" />操作日志
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <el-dialog
      title="列设置"
      :visible.sync="columnSettingVisible"
      width="480px"
      custom-class="column-setting-dialog"
    >
      <ColumnDrag :columns="columns" @update="applyColumnSettings" />
    </el-dialog>
    <vxe-modal
      v-model="details"
      title="货源单详情"
      width="1000"
      height="600"
      resize
    >
      <ordergoods ref="detailRef" />
    </vxe-modal>
    <vxe-modal
      v-model="distr"
      title="推送"
      width="1000"
      height="80%"
      resize
      @close="handleCancel"
    >
      <distribute ref="distrRef" :huoyuan="huoyuanDtile" />
    </vxe-modal>
    <vxe-modal v-model="price" title="价格调整" width="400" height="350" resize>
      <reject ref="Modifyprice" @guanbi="priceFalse" />
    </vxe-modal>
    <vxe-modal
      v-model="distrlist"
      title="派单列表"
      width="1000"
      height="80%"
      resize
    >
      <distrilistbute ref="distrlistRef" />
    </vxe-modal>
    <vxe-modal
      v-model="offerlist"
      title="报价列表"
      width="1000"
      height="80%"
      resize
    >
      <offerlistorder ref="offerlistRef" />
    </vxe-modal>
    <vxe-modal
      v-model="enClosureFlag"
      title="电子围栏"
      width="1000"
      height="80%"
      resize
    >
      <enClosure
        :key="timer"
        ref="enClosureRef"
        :paranents="paranents"
        @fatherSubmitMethod="fatherSubmitFunc"
        @fatherCancelMethod="fatherCancelFunc"
      />
    </vxe-modal>
    <vxe-modal
      v-model="isLogList"
      title="操作日志"
      width="900"
      height="700"
      resize
    >
      <LogList v-if="isLogList" :row-info="rowInfo" log-type="source" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
    <see-code
      :info="qrcodeInfo.order"
      :row="rowData"
      :code-url="qrcodeInfo.qrcode"
      :type="codeType"
      :branch-name="qrcodeInfo.branchName"
      @closePopup="closeCode"
    />
    <SimpleSeeCode
      :info="qrcodeInfo.order"
      :row="rowData"
      :code-url="qrcodeInfo.qrcode"
      :type="isSimpleCode"
      :branch-name="qrcodeInfo.branchName"
      @closePopup="closeCode"
    />
  </div>
</template>
<script>
import {
  SupplyManagement,
  querySubLis,
  deleteOrder,
  cancelOrder,
  finishOrder,
  orderRefreshApi,
  cancelOftenOrder,
  GetMapTag,
  qrcode
} from "@/api/orderform";
import ColumnDrag from "@/components/ColumnDrag.vue";
import { getLimit } from "@/utils/getLimit.js";
import ordergoods from "@/components/TransportOrderDetails";
import distribute from "./components/distribute.vue";
import distrilistbute from "./components/distrilistbute.vue";
import offerlistorder from "./components/offerlistorder.vue";
import enClosure from "./components/enclosure.vue";
import reject from "./components/reject.vue";
import DownloadCode from "./components/downloadCode.vue";
import SeeCode from "./components/seeCode.vue";
import SimpleSeeCode from "./components/simpleSeeCode.vue";
import LogList from "@/views/basicInfo/driver/platVehicle/components/LogList.vue";
export default {
  name: "Ordermanage",
  components: {
    LogList,
    ordergoods,
    distribute,
    reject,
    distrilistbute,
    offerlistorder,
    enClosure,
    DownloadCode,
    SeeCode,
    SimpleSeeCode,
    ColumnDrag
  },
  inject: ["reload"],
  data() {
    return {
      showTable: true,
      columnSettingVisible: false,
      columns: [
        {
          name: "承运主体",
          value: "branchCode",
          visible: true,
          minWidth: 230
        },
        {
          name: "货源单号",
          value: "mainOrderNumber",
          visible: true,
          minWidth: 200
        },
        {
          name: "来源单号",
          value: "sourceOrderNumber",
          visible: true,
          minWidth: 200
        },
        {
          name: "项目名称",
          value: "projectName",
          visible: true,
          minWidth: 200
        },
        {
          name: "线路简称",
          value: "lineName",
          visible: true,
          minWidth: 200
        },
        {
          name: "接单方式",
          value: "receiveOrderMethod",
          visible: true,
          minWidth: 200
        },
        {
          name: "托运人",
          value: "companyName",
          visible: true,
          minWidth: 260
        },
        {
          name: "经办人",
          value: "dfName",
          visible: true,
          minWidth: 120
        },
        {
          name: "托运人类型",
          value: "shipmentStaffTypeStr",
          visible: true,
          minWidth: 160
        },
        {
          name: "托运人电话",
          value: "createdByPhone",
          visible: true,
          minWidth: 160
        },
        {
          name: "结算类型",
          value: "isMonthlyOrder",
          visible: true,
          minWidth: 100
        },
        {
          name: "装货地址",
          value: "placeOfShipment",
          visible: true,
          minWidth: 350
        },
        {
          name: "收货地址",
          value: "placeOfReceipt",
          visible: true,
          minWidth: 350
        },
        {
          name: "订单状态",
          value: "status",
          visible: true,
          minWidth: 130
        },
        {
          name: "订单类型",
          value: "isQuote",
          visible: true,
          minWidth: 130
        },
        {
          name: "是否结束",
          value: "isFinishOrder",
          visible: true,
          minWidth: 130
        },
        {
          name: "是否撤销",
          value: "isCancel",
          visible: true,
          minWidth: 130
        },
        {
          name: "货物名称",
          value: "coalTypeName",
          visible: true,
          minWidth: 130
        },
        {
          name: "货物类型",
          value: "coalBigTypeName",
          visible: true,
          minWidth: 180
        },
        {
          name: "是否常发货源",
          value: "isOftenOrder",
          visible: true,
          minWidth: 130
        },
        {
          name: "运输要求",
          value: "coalName",
          visible: true,
          minWidth: 130
        },
        {
          name: "货物单价",
          value: "coalPrice",
          visible: true,
          minWidth: 200
        },
        {
          name: "货物总价(元)",
          value: "goodsTotal",
          visible: true,
          minWidth: 200
        },
        {
          name: "运费单价",
          value: "price",
          visible: true,
          minWidth: 200
        },
        {
          name: "承运单价",
          value: "realPrice",
          visible: true,
          minWidth: 200
        },
        {
          name: "是否预付",
          value: "payType",
          visible: true,
          minWidth: 130
        },
        {
          name: "预付款(元)",
          value: "prePay",
          visible: true,
          minWidth: 200
        },
        {
          name: "是否到付",
          value: "arrivePayType",
          visible: true,
          minWidth: 130
        },
        {
          name: "到付款(元)",
          value: "arrivePay",
          visible: true,
          minWidth: 200
        },
        {
          name: "是否回单付",
          value: "returnPayType",
          visible: true,
          minWidth: 130
        },
        {
          name: "回单付款(元)",
          value: "returnPay",
          visible: true,
          minWidth: 200
        },
        {
          name: "浮动费用(元)",
          value: "driftPrice",
          visible: true,
          minWidth: 200
        },
        {
          name: "实际承运人预估费用(元)",
          value: "dirverEstimatePay",
          visible: true,
          minWidth: 200
        },
        {
          name: "预估托运人费用(元)",
          value: "shipperEstimatePay",
          visible: true,
          minWidth: 200
        },
        {
          name: "服务费(元)",
          value: "serInfoPay",
          visible: true,
          minWidth: 200
        },
        {
          name: "运输距离(公里)",
          value: "distance",
          visible: true,
          minWidth: 200
        },
        {
          name: "货物数量",
          value: "weight",
          visible: true,
          minWidth: 200
        },
        {
          name: "剩余数量",
          value: "lastWeight",
          visible: true,
          minWidth: 200
        },
        {
          name: "需求车数(车)",
          value: "coalNumber",
          visible: true,
          minWidth: 200
        },
        {
          name: "未接车数(车)",
          value: "notReceivedCount",
          visible: true,
          minWidth: 200
        },
        {
          name: "已接车数(车)",
          value: "receivedCount",
          visible: true,
          minWidth: 200
        },
        {
          name: "装车时间",
          value: "lastLoadingTime",
          visible: true,
          minWidth: 420
        },
        {
          name: "卸车时间",
          value: "lastUnloadingTime",
          visible: true,
          minWidth: 420
        },
        {
          name: "创建时间",
          value: "gmtCreated",
          visible: true,
          minWidth: 420
        },
        {
          name: "最后操作时间",
          value: "gmtModified",
          visible: true,
          minWidth: 420
        },
        {
          name: "最后操作人",
          value: "modifiedByName",
          visible: true,
          minWidth: 130
        }
      ],
      isSimpleCode: false,
      rowInfo: null,
      isLogList: false,
      rowData: {},
      codeType: false,
      qrcodeInfo: {
        order: {},
        qrcode: ""
      },
      timer: "",
      paranents: {
        orderCode: "",
        branchCode: ""
      },
      huoyuanDtile: "",
      partyType: this.$store.getters.party.partyType,
      message: "",
      loading: false,
      details: false,
      price: false,
      distr: false,
      distrlist: false,
      offerlist: false,
      enClosureFlag: false,
      order_manage_search_button: false, //查询
      order_manage_detail_button: false, //详情
      order_manage_endsourcedoc_button: false, //结束货源单
      order_manage_copy_button: false, //复制
      order_manage_distr_button: false, //推送
      order_manage_edit_button: false, //编辑
      order_manage_delete_button: false, //删除
      order_manage_enclosure_button: false, //电子围栏
      order_manage_suspend_button: false, //暂停
      order_manage_orderrefresh_button: false, //刷新
      order_manage_reject_button: false, //调价
      order_manage_offer_button: false, //报价
      order_manage_paidanlist_button: false, //派单列表
      order_manage_canceloftenorder_button: false, //取消常发
      tableData: [],
      parentData: {
        isMonthlyOrderOptions: []
      },
      sumObject: {},
      listQuery: {
        lastLoadingTimeRange: [],
        lastUnloadingTimeRange: [],
        gmtCreatedRange: [],
        gmtModifiedRange: [],
        isFinishOrder: "",
        isCancel: "",
        pageNum: 1,
        pageSize: 20,
        total: 0
      },
      // Pagingconf: [],
      toolbarButtons: [
        {
          code: "btn1",
          name: "查询"
        }
      ],
      options: [
        {
          value: "0",
          label: "未接单"
        },
        {
          value: "1",
          label: "已接单"
        },
        {
          value: "2",
          label: "已装货"
        },
        {
          value: "3",
          label: "已卸货"
        },
        {
          value: "4",
          label: "已结算"
        },
        {
          value: "5",
          label: "已完成"
        }
      ],
      options2: [
        {
          value: "0",
          label: "现付开票"
        },
        {
          value: "1",
          label: "到付开票"
        },
        {
          value: "2",
          label: "代付开票"
        }
      ],
      options3: [
        {
          value: "0",
          label: "否"
        },
        {
          value: "1",
          label: "是"
        }
      ],
      shipmentOptions: [
        { label: "个体托运人", value: 0 },
        { label: "企业托运人", value: 1 }
      ],
      isQuoteMap: { 0: "普通单", 1: "报价单", 2: "指派单" },
      cancels: [{ value: 0, label: "未撤销" }, { value: 1, label: "已撤销" }],
      finishOrders: [{ value: 0, label: "否" }, { value: 1, label: "是" }],
      // 机构列表
      branchList: this.$store.state.components.branchList,
      exportObj: {
        exportUrl: "/ntocc-tms-api/order/exportOrderManage", //导出接口
        name: "货源管理"
      }
    };
  },
  watch: {
    $route: {
      handler(to, from) {
        const v = to.query.todo;
        console.log("路由切换========", v);
        // if (v) {
        //   this.listQuery.isCancel = 0;
        //   this.listQuery.isFinishOrder = 0;
        // } else {
        //   this.listQuery.isCancel = "";
        //   this.listQuery.isFinishOrder = "";
        // }
        if (v == 1) {
          this.listQuery.status = "0";
        }
        this.listQuery = {
          lastLoadingTimeRange: [],
          lastUnloadingTimeRange: [],
          gmtCreatedRange: [],
          gmtModifiedRange: [],
          isFinishOrder: "",
          isCancel: "",
          pageNum: 1,
          pageSize: 20,
          total: 0
        };
        this.findList();
      },
      immediate: true // 立即执行一次
    },
    "$store.state.tagsView.cachedViews": function(cachedViews) {
      if (!cachedViews.includes("Ordermanage")) {
        let route = this.getRoute(this.$router.options.routes);
        route.meta.keepLive = false;
      }
    }
  },
  created() {
    const v = this.$route.query.todo;
    if (v) {
      this.listQuery.isCancel = 0;
      this.listQuery.isFinishOrder = 0;
    }
    this.parentData.isMonthlyOrderOptions = [
      { label: "次结", value: 0 },
      { label: "月结", value: 1 }
    ];
    this.findList();
    this.order_manage_search_button = getLimit("order_manage_search_button"); //查询
    this.order_manage_detail_button = getLimit("order_manage_detail_button"); //详情
    this.order_manage_endsourcedoc_button = getLimit(
      "order_manage_endsourcedoc_button"
    ); //结束货源单
    this.order_manage_copy_button = getLimit("order_manage_copy_button"); //复制
    this.order_manage_distr_button = getLimit("order_manage_distr_button"); //推送
    this.order_manage_edit_button = getLimit("order_manage_edit_button"); //编辑
    this.order_manage_delete_button = getLimit("order_manage_delete_button"); //删除
    // 围栏开关
    GetMapTag().then(res => {
      this.mapTag = res.data == "1" ? true : false;
      this.order_manage_enclosure_button =
        getLimit("order_manage_enclosure_button") && res.data == "1"; //电子围栏
    });
    this.order_manage_suspend_button = getLimit("order_manage_suspend_button"); //暂停
    this.order_manage_orderrefresh_button = getLimit(
      "order_manage_orderrefresh_button"
    ); //刷新
    this.order_manage_reject_button = getLimit("order_manage_reject_button"); //调价
    this.order_manage_offer_button = getLimit("order_manage_offer_button"); //报价
    this.order_manage_paidanlist_button = getLimit(
      "order_manage_paidanlist_button"
    ); //派单列表
    this.order_manage_canceloftenorder_button = getLimit(
      "order_manage_canceloftenorder_button"
    ); //取消常发
    let unLoadedColumn = localStorage.getItem("GoodsSourceColumn") || "";
    if (unLoadedColumn) {
      this.columns = JSON.parse(unLoadedColumn);
    }
  },
  computed: {
    isSub() {
      return this.$route.path.includes("sub_order_manage");
    }
  },
  methods: {
    copyText(text) {
      if (!text) return;
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message({
        message: "复制成功",
        type: "success",
        duration: 1500
      });
    },
    formatterSwitch(scope) {
      // 实际承运人净得判断 未签收：deliveryFeeDeserved  已签收：deliveryFeePractical
      let valueCell = scope.row[scope.column.property];

      if (scope.column.property === "branchCode") {
        const item = this.branchList.find(item => item.code === valueCell);
        return item ? item.groupName : "";
      }
      if (scope.column.property === "goodsTotal") {
        return valueCell === 0 ? null : valueCell;
      }
      if (scope.column.property === "receiveOrderMethod") {
        switch (valueCell) {
          case 0:
            return "发布至大厅";
          case 1:
            return "仅扫码接单";
          default:
            return "--";
        }
      }
      if (scope.column.property === "isMonthlyOrder") {
        const item = this.parentData[`isMonthlyOrderOptions`].find(
          item => item.value === valueCell
        );
        return item ? item.label : "";
      }
      if (scope.column.property === "status") {
        // console.log("valueCell=========status====", valueCell);
        switch (valueCell) {
          case 0:
            return "未接单";
          case 1:
            return "已接单";
          case 2:
            return "已装货";
          case 3:
            return "已卸货";
          case 4:
            return "已结算";
          case 5:
            return "已完成";
          default:
            return "--";
        }
      }
      if (scope.column.property === "isQuote") {
        if (!scope.row) {
          return null;
        }
        let genre = valueCell;
        if (scope.row.pushTarget != void 0 && scope.row.pushTarget != "") {
          genre = 2;
        }
        return this.isQuoteMap[genre];
      }
      if (scope.column.property === "isFinishOrder") {
        for (let j = 0, len = this.finishOrders.length; j < len; j++) {
          if (this.finishOrders[j].value == valueCell) {
            return this.finishOrders[j].label;
          }
        }
      }
      if (scope.column.property === "isCancel") {
        for (let j = 0, len = this.cancels.length; j < len; j++) {
          if (this.cancels[j].value == valueCell) {
            return this.cancels[j].label;
          }
        }
      }
      if (
        scope.column.property === "isOftenOrder" ||
        scope.column.property === "payType" ||
        scope.column.property === "arrivePayType" ||
        scope.column.property === "returnPayType"
      ) {
        switch (valueCell) {
          case 0:
            return "否";
          case 1:
            return "是";
          default:
            break;
        }
      }

      return valueCell;
    },
    applyColumnSettings(payload) {
      this.columns = payload.columns;
      localStorage.setItem(
        "GoodsSourceColumn",
        JSON.stringify(payload.columns)
      );
      this.columnSettingVisible = false;
      this.showTable = false;
      this.$nextTick(() => {
        this.showTable = true;
      });
      this.$forceUpdate();
    },
    // formatterReceiveOrderMethod(row) {
    //   if (row.receiveOrderMethod == 0) {
    //     return "发布至大厅";
    //   } else if (row.receiveOrderMethod == 1) {
    //     return "仅扫码接单";
    //   }
    // },
    watchLog(code, row) {
      this.rowInfo = row;
      this.isLogList = true;
    },
    formatterReceiveOrderMethod({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "发布至大厅";
        case 1:
          return "仅扫码接单";
        default:
          return "--";
          break;
      }
    },
    closeCode() {
      this.codeType = false;
      this.isSimpleCode = false;
    },
    getCode(code, row, isSimple = false) {
      this.rowData = row;
      console.log("=======??", row);
      qrcode({ ordercode: code })
        .then(response => {
          if (isSimple) {
            this.isSimpleCode = true;
          } else {
            this.codeType = true;
          }
          console.log("info", code, response);
          this.qrcodeInfo = response.data;
          let branchName = this.formatterBranch({ cellValue: row.branchCode });
          console.log(
            "名字======",
            branchName,
            "row.branchCode",
            row.branchCode
          );
          this.qrcodeInfo.branchName = branchName;
          if (this.qrcodeInfo && this.qrcodeInfo.qrcode) {
            let cideList = this.qrcodeInfo.qrcode.split(".com");
            let url = this.qrcodeInfo.qrcode;
            if (cideList && cideList.length) {
              url = window.BaseUrl.ApiUrl + "/pic" + cideList[1];
              // url = "https://test-wccy.minliankeji.com/pic" + cideList[1];
            }
            this.qrcodeInfo.qrcode = url;
            console.log("查看二维码", url);
          }
        })
        .finally(() => {});
    },
    handleCancel() {
      this.$refs.distrRef.close();
    },
    getRoute(routerList) {
      var list = "";
      for (let item of routerList) {
        if (item.children) {
          let clist = this.getRoute(item.children);
          if (this.getRoute(item.children)) {
            return clist;
          }
        }
        if (item.name == "Ordermanage") {
          list = item;
          return list;
        }
      }
      return list;
    },
    fatherSubmitFunc() {
      this.enClosureFlag = false;
    },
    fatherCancelFunc() {
      this.enClosureFlag = false;
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        let api = this.$route.path.includes("sub_order_manage")
          ? querySubLis
          : SupplyManagement;
        api(this.listQuery)
          .then(response => {
            const records = response.data.records;
            if (records && records.length > 0) {
              for (const i in records) {
                this.showBtnsHandler(records[i]);
              }
              this.tableData = records;
            } else {
              this.tableData = [];
            }
            this.tableData.forEach(item => {
              item.price = item.price + item.isTrunkName;
              item.realPrice = item.realPrice + item.isTrunkName;
              item.coalPrice =
                item.coalPrice === 0 ? null : item.coalPrice + item.isTrunkName;
              item.maxPrice = item.maxPrice + item.isTrunkName;
              item.maxTaxPrice = item.maxTaxPrice + item.isTrunkName;
              item.maxRealPrice = item.maxRealPrice + item.isTrunkName;
              item.weight = item.weight + item.coalUnitName;
              item.lastWeight = item.lastWeight + item.coalUnitName;
              item.taxPrice = item.taxPrice + item.isTrunkName;
            });
            this.listQuery.total = response.data.total;
            this.sumObject = response.data.sumObject;
            resolve();
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    formatterQuote(data) {
      if (!data.row) {
        return null;
      }
      let genre = data.row.isQuote;
      if (data.row.pushTarget != void 0 && data.row.pushTarget != "") {
        genre = 2;
      }
      return this.isQuoteMap[genre];
    },
    // 删除货源单
    del(code) {
      this.$confirm("删除货源单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteOrder(code).then(response => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.findList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 暂停货源单
    suspend(code) {
      this.$confirm("确认要撤销发布吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          cancelOrder(code).then(response => {
            this.$message({
              type: "success",
              message: "撤销成功!"
            });
            this.findList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 货源单结束
    Endsourcedoc(c) {
      console.log("结束货源单========", c);
      this.$confirm("请确认是否结束货源?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          finishOrder(c).then(response => {
            this.$message({
              type: "success",
              message: "结束成功!"
            });
            this.findList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 取消常发货源单设置
    cancelOftenOrder(code) {
      this.$confirm("确认要取消常发设置吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        cancelOftenOrder(code).then(response => {
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.findList();
        });
      });
    },
    /*
      Modifyprice(row) {
        this.price = true
      }, */
    orderRefresh(c) {
      orderRefreshApi(c).then(response => {
        this.$message({
          type: "success",
          message: response.msg
        });
        this.findList();
      });
    },
    copyClick(code) {
      this.$router.push({
        path: "/order/order_publish",
        query: {
          mallCode: code
        }
      });
    },
    editClick(info) {
      this.$router.push({
        path: "/order/order_publish",
        query: {
          mallCode: info.code,
          status: info.status,
          show: "0",
          type: "edit" //编辑
        }
      });
    },
    distrClick(params) {
      this.huoyuanDtile = params.huoyuan;
      this.$refs.distrRef.Getdistr(params);
      this.distr = true;
    },
    paidanList(row) {
      this.$refs.distrlistRef.Getdistr(row);
      this.distrlist = true;
    },
    // 报价
    offerOrder(code) {
      this.$refs.offerlistRef.Getdistr(code);
      this.offerlist = true;
    },
    rejectClick(row) {
      this.$refs.Modifyprice.Getdistr(row);
      this.price = true;
    },
    priceFalse() {
      this.price = false;
      this.findList();
    },
    rowClassName({ row }) {
      // console.log("行名=======", row.isFinishOrder, typeof row.isFinishOrder);
      if (row.isFinishOrder === 1) {
        return "row-gray";
      }
    },
    cellClassName({ row, rowIndex, column, columnIndex }) {
      if (column.property === "status") {
        switch (row.status) {
          case 0:
            return "col-red";
          case 1:
            return "col-green";
          case 2:
            return "col-orange";
          case 3:
            return "col-red";
          case 4:
            return "col-green";
          case 5:
            return "col-orange";

          default:
            break;
        }
      }
    },
    enClosure(row) {
      this.timer = new Date().getTime();
      this.paranents.orderCode = row.code;
      this.enClosureFlag = true;
    },
    handleClick(code) {
      this.$refs.detailRef.Getdetails(code);
      this.details = true;
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      console.log("!!!!!!!!!!!!!", cellValue);
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterStatus({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "未接单";
        case 1:
          return "已接单";
        case 2:
          return "已装货";
        case 3:
          return "已卸货";
        case 4:
          return "已结算";
        case 5:
          return "已完成";

        default:
          break;
      }
    },
    frequentGoods({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "否";
        case 1:
          return "是";
        default:
          break;
      }
    },
    billingTypeStatus({ cellValue }) {
      switch (cellValue) {
        case "0":
          return "现付开票";
        case "1":
          return "到付开票";
        case "2":
          return "代付开票";
        default:
          break;
      }
    },

    formatterisQuote({ cellValue }) {
      switch (cellValue) {
        case "0":
          return "普通单";
        case "1":
          return "报价单";
        default:
          break;
      }
    },
    formatterFinishs({ cellValue }) {
      for (let j = 0, len = this.finishOrders.length; j < len; j++) {
        if (this.finishOrders[j].value == cellValue) {
          return this.finishOrders[j].label;
        }
      }
    },
    formatterCancels({ cellValue }) {
      for (let j = 0, len = this.cancels.length; j < len; j++) {
        if (this.cancels[j].value == cellValue) {
          return this.cancels[j].label;
        }
      }
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (["coalNumber"].includes(column.property)) {
            return this.sumObject.coalNumber;
          }
          if (["weight"].includes(column.property)) {
            return (
              (this.sumObject.ton || 0) +
              "吨//" +
              (this.sumObject.cubicMeter || 0) +
              "方//" +
              (this.sumObject.pieces || 0) +
              "件"
            );
          }
          if (["lastWeight"].includes(column.property)) {
            return (
              (this.sumObject.lastTon || 0) +
              "吨//" +
              (this.sumObject.lastCubicMeter || 0) +
              "方//" +
              (this.sumObject.lastPieces || 0) +
              "件"
            );
          }
          if (["goodsTotal"].includes(column.property)) {
            return this.sumObject.goodsTotal;
          }
          if (["allFee"].includes(column.property)) {
            return this.sumObject.allFee;
          }
          if (["taxFee"].includes(column.property)) {
            return this.sumObject.taxFee;
          }
          if (["taxPayFee"].includes(column.property)) {
            return this.sumObject.taxPayFee;
          }
          if (["distance"].includes(column.property)) {
            return this.sumObject.distance;
          }
          if (["notReceivedCount"].includes(column.property)) {
            return this.sumObject.notReceivedCount;
          }
          if (["receivedCount"].includes(column.property)) {
            return this.sumObject.receivedCount;
          }
          if (["transferCount"].includes(column.property)) {
            return this.sumObject.transferCount;
          }
          return "-";
        })
      ];
    },
    showBtnsHandler(row) {
      const btnArr = [];
      if (
        this.order_manage_edit_button &&
        row.status === 0 &&
        row.isFinishOrder === 0
      ) {
        btnArr.push("edit"); // 编辑
      }
      if (this.order_manage_delete_button && row.status === 0) {
        btnArr.push("delete"); // 删除
      }
      if (this.order_manage_enclosure_button) {
        btnArr.push("enclosure"); // 电子围栏
      }
      if (
        this.order_manage_suspend_button &&
        row.isCancel === 0 &&
        row.isFinishOrder === 0
      ) {
        btnArr.push("suspend"); // 暂停
      }
      if (
        this.order_manage_orderrefresh_button &&
        row.isCancel === 1 &&
        row.isFinishOrder === 0
      ) {
        btnArr.push("orderrefresh"); // 刷新
      }
      if (
        this.order_manage_reject_button &&
        row.isCancel === 0 &&
        row.isFinishOrder === 0
      ) {
        btnArr.push("reject"); // 调价
      }
      if (this.order_manage_offer_button && row.isQuote == 1) {
        btnArr.push("offer"); // 报价
      }
      if (
        this.order_manage_paidanlist_button &&
        row.pushTarget != null &&
        row.pushTarget != ""
      ) {
        btnArr.push("paidanList"); // 派单列表
      }
      if (this.order_manage_canceloftenorder_button && row.isOftenOrder == 1) {
        btnArr.push("cancelOftenOrder"); // 取消常发
      }
      // row.status === 0 || row.status === 1
      if (row.notReceivedCount > 0) {
        btnArr.push("qrCode"); // 查看二维码
      }
      row.btnArr = btnArr;
    }
  }
};
</script>
<style scoped>
.copy_text_span {
  white-space: pre-wrap;
  cursor: pointer;
  &:hover {
    font-weight: bold;
  }
}
.oeder_num_box {
  position: relative;
}
.icon_yu {
  position: absolute;
  top: -9px;
  right: -4px;
  width: 20px;
  height: 20px;
}
::v-deep .vxe-table--footer-wrapper.body--wrapper::-webkit-scrollbar {
  -webkit-appearance: none; /* 禁用默认样式 */
  height: 12px !important; /* 设置滚动条高度（常驻显示） */
  background-color: #f1f1f1; /* 轨道背景色 */
}
::v-deep .vxe-table--footer-wrapper.body--wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important; /* 滑块颜色 */
  border-radius: 5px !important; /* 滑块圆角 */
}
/* 针对微信浏览器定制滚动条 */
::v-deep
  .vxe-table:not(.is--empty).show--foot.scroll--x
  .vxe-table--body-wrapper::-webkit-scrollbar {
  -webkit-appearance: none; /* 禁用默认样式 */
  height: 12px !important; /* 设置滚动条高度（常驻显示） */
  background-color: #f1f1f1; /* 轨道背景色 */
}

::v-deep
  .vxe-table:not(.is--empty).show--foot.scroll--x
  .vxe-table--body-wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important; /* 滑块颜色 */
  border-radius: 5px !important; /* 滑块圆角 */
}
</style>
<style>
.mytable-footer .vxe-body--row.row-gray {
  background-color: rgb(205, 202, 202) !important;
}
.mytable-footer .vxe-body--row.row-green {
  background-color: #187;
  color: #2db7f5;
}
.mytable-footer .vxe-header--column.col-blue {
  background-color: #2db7f5;
  color: #fff;
}
.mytable-footer .vxe-body--column.col-red {
  color: #f00;
}
.mytable-footer .vxe-body--column.col-orange {
  color: #f60;
}

.mytable-footer .vxe-body--column.col-green {
  color: rgb(29, 47, 202);
}
</style>
